import { render, staticRenderFns } from "./RunComponenet.vue?vue&type=template&id=3cd36480"
import script from "./RunComponenet.vue?vue&type=script&lang=js"
export * from "./RunComponenet.vue?vue&type=script&lang=js"
import style0 from "./RunComponenet.vue?vue&type=style&index=0&id=3cd36480&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports